import React from 'react';
import { Button } from '@leverege/ui-elements';
import useWizard from "./useWizard.js";
export default function Footer(props) {
  const {
    activeStep,
    runAction,
    nextDisabled,
    nextText,
    backText
  } = useWizard();
  return /*#__PURE__*/React.createElement(React.Fragment, null, activeStep.onBack ? /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    eventData: activeStep.onBack,
    onClick: runAction
  }, backText || 'Back') : /*#__PURE__*/React.createElement("div", null), activeStep.onNext && /*#__PURE__*/React.createElement(Button, {
    disabled: nextDisabled,
    variant: "primary",
    eventData: activeStep.onNext,
    onClick: runAction
  }, nextText || 'Next'));
}